import { render, staticRenderFns } from "./ColleagueWorkInfo.vue?vue&type=template&id=5a344692&scoped=true&"
import script from "./ColleagueWorkInfo.vue?vue&type=script&lang=js&"
export * from "./ColleagueWorkInfo.vue?vue&type=script&lang=js&"
import style0 from "./ColleagueWorkInfo.vue?vue&type=style&index=0&id=5a344692&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a344692",
  null
  
)

export default component.exports